<template>
  <div class="localinfoItem"
    :class="{
      hasPhotos: !!item.sitePhotos,
      hide: !itemVisible}">
    <div class="checkbox chkDisplay">
      <input type="checkbox" :id="`display_${item.placeId}`" v-model="itemVisible" :checked="itemVisible" />
      <label :for="`display_${item.placeId}`"><span class="blind">{{locale.state_public}}</span></label>
    </div>
    <!-- <span v-if="item.recommend" class="recommended"></span> -->
    <div class="chkRecommend">
      <input type="checkbox" :id="`recommend_${item.placeId}`" v-model="itemRecoomend" :checked="itemRecoomend" />
      <label :for="`recommend_${item.placeId}`"><span class="blind">{{locale.recommend}}</span></label>
    </div>
    <div v-if="!!item.sitePhotos" class="thumb"
      :style="{backgroundImage: sitePhotos(item.sitePhotos[0])}">
    </div>
    <div class="info">
      <p class="place mb5">
        <span v-if="item.icon" class="icon"><img :src="item.icon" /></span>
        <span class="name">{{item.name}}</span>
      </p>
      <p class="address colorGrey">{{item.formatted_address}}</p>
      <p class="long mt10">
        <span class="distance">{{distance}}</span>
        <span class="walking">({{onfoot}})</span>
      </p>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  props: [
    'locale',
    'item'
  ],
  computed: {
    itemRecoomend: {
      get () {
        return this.item.recommend
      },
      set (recommend) {
        const data = {
          placeId: this.item.placeId,
          value: recommend
        }
        this.$store.commit('localinfo/setRecommend', data)
      }
    },
    itemVisible: {
      get () {
        const hide = this.item.visible === false
        return !hide
      },
      set (visible) {
        const data = {
          placeId: this.item.placeId,
          value: visible
        }
        this.$store.commit('localinfo/setDisplay', data)
      }
    },
    distance () {
      const distance = this.item.distance
      const d = distance >= 1000 ? (distance / 1000).toFixed(1) : distance
      const unit = distance >= 1000 ? 'km' : 'm'
      return `${this.locale.localinfo_fromhotel} ${regExp.comma(d)}${unit}`
    },
    onfoot () {
      const secPerDistance = Math.floor(this.item.distance * 0.9) // sec per distance :: 1분에 66.6m -> 1m당 0.9초
      const LOCALE = this.locale
      function minSec (seconds) {
        const hour = parseInt(seconds / 3600)
        const min = parseInt((seconds % 3600) / 60)
        // const sec = seconds % 60
        let message = `${LOCALE.localinfo_onfoot} `
        if (seconds <= 60) {
          message += LOCALE.within1min
        } else {
          if (hour >= 1) {
            message += `${LOCALE.time_about} ${hour}${LOCALE.hour}`
          }
          if (min >= 1) {
            message += `${LOCALE.time_about} ${min}${LOCALE.minute}`
          }
          // if (sec >= 1) {
          //   message = message += ` ${sec}${LOCALE.seconds}`
          // }
        }
        return message
      }
      return minSec(secPerDistance)
    }
  },
  methods: {
    sitePhotos (img) {
      return `url('https://google-map-photos.s3.ap-northeast-2.amazonaws.com/${img}')`
    }
  }
}
</script>

<style lang="scss" scoped>
.localinfoItem {
  display: flex;
  position: relative;
  margin-bottom: 15px;
  padding-left: 30px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  &.hasPhotos {
    padding-left: 150px;
  }
  .thumb {
    position: absolute;
    top: 0;
    left: 0;
    width: 150px;
    height: 100%;
    border: 2px solid $color-white;
    border-right: none;
    border-radius: 4px 0 0 4px;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    box-shadow: inset 0 -10px 10px rgba(0,0,0,0.25);
  }
}
.hide {
  opacity: 0.5;
}
.info {
  padding: 15px 15px 30px 15px;
  .place {
    position: relative;
    padding-left: 24px;
  }
  .icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 16px;
  }
  .name {
    font-size: 1.1em;
    font-weight: 700;
  }
  .long {
    color: $color-lgrey;
  }
  .walking {
    margin-left: 0.5em;
  }
}
.chkDisplay {
  position: absolute;
  top: 5px;
  left: 5px;
  border: 1px solid rgba($color-white, 0.5);
  z-index: 2;
  label {
    height: 22px;
    padding-left: 22px;
  }
}
.chkRecommend {
  position: absolute;
  top: 50%;
  left: -4px;
  z-index: 2;
  label {
    display: block;
    width: 32px;
    height: 40px;
    margin-top: -20px;
    border-radius: 0 4px 4px 0;
    border: 1px solid $color-lgrey;
    background: $color-lgrey2 url('~@/assets/img/ico_recommend.png') 50% 50% / 22px no-repeat;
    box-shadow: 0 0 5px rgba(0,0,0,0.1);
    cursor: pointer;
  }
  :checked + label {
    border-color: $color-white;
    background-color: $color-blue;
  }
}
.chkDisabled {
  position: absolute;
  top: 5px;
  right: 5px;
  label:before {
    content: "";
    display: block;
    width: 20px;
    height: 20px;
    background: url('~@/assets/img/ico_disabled_off.png') 50% 50% / contain no-repeat;
    opacity: 0.3;
    cursor: pointer;
  }
  :checked + label:before {
    background-image: url('~@/assets/img/ico_disabled_on.png');
    opacity: 1;
  }
}
.option {
  margin-top: auto;
  padding: 15px;
  border-top: 1px solid $color-lgrey2;
}
.optionItem {
  display: flex;
  align-items: center;
  & + .optionItem {
    margin-top: 5px;
  }
  .optionLabel {
    flex: 1;
  }
  .optionValue {
    flex: 1.2;
  }
  .input {
    min-width: 0;
    min-height: 0;
    padding: 0.2em 0.8em;
    border: 1px solid $color-lgrey2;
  }
}
</style>
